import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@rtkwlf/pro-solid-svg-icons/faUpRightFromSquare';
import { useTranslation } from 'react-i18next';

import { Box, Popover, Typography } from '@packages/fenrir/components';

interface ItsmPopoverProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  bodyText?: string;
  linkText?: string;
}

export const ItsmPopover = ({
  anchorEl,
  open,
  onClose,
  linkText,
  bodyText,
}: ItsmPopoverProps) => {
  const { t } = useTranslation('notifications');
  return (
    <Popover
      id="itsm-popover"
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      disableRestoreFocus
      slotProps={{
        paper: { sx: { p: 1 } },
      }}
    >
      <Typography variant="body2">{bodyText}</Typography>
      {linkText && (
        <Box
          component="a"
          href={t('itsmPopover.docsUrl')}
          target="_blank"
          rel="noreferrer"
          display="inline-flex"
          alignItems="center"
          sx={{
            color: 'primary.main',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
          tabIndex={0}
        >
          <Typography variant="body2" marginRight={0.5} display="inline">
            {linkText}
          </Typography>
          <Box
            component="span"
            display="inline-flex"
            alignItems="center"
            height="100%"
          >
            <FontAwesomeIcon
              icon={faUpRightFromSquare}
              size="sm"
              style={{ marginLeft: '4px', color: 'gray', alignSelf: 'center' }}
              data-testid="external-link-icon"
            />
          </Box>
        </Box>
      )}
    </Popover>
  );
};

export default ItsmPopover;
